import React, {Component} from 'react'
import {connect} from 'react-redux'
import Resources from '../../../data/services/resources'
import Page from "../../../common/components/layout/layout-components/page";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";
import NavResponsive from "../../../common/components/nav-responsive";
import MobileTabs from "../../../common/components/tabs-navigation/mobile-tabs";
import Layout from "../../../common/components/layout";
import ScheduledMaintenanceTab from "./scheduledMaintenanceTab";
import {checkPerm} from "../../../common/util/util-helpers";
import {READ_PERM} from "../../../common/util/util-consts";
import UpcomingMaintenanceTab from "./upcomingMaintenanceTab";

class ScheduledMaintenancePageView extends Component {
    constructor(props) {
        super(props)

        const tabs = [
            {
                name: 'Schedule Maintenance',
                resource: Resources.WorkOrderScheduledMaintenance,
                current: true,
                visible: checkPerm(Resources.WorkOrderScheduledMaintenance, READ_PERM)
            },
            {
                name: 'Upcoming Maintenance',
                resource: Resources.WorkOrderUpcomingMaintenance,
                current: false,
                visible: checkPerm(Resources.WorkOrderUpcomingMaintenance, READ_PERM)
            }
        ]

        this.state = {
            tabs: tabs,
            selectedTab: Resources.WorkOrderScheduledMaintenance,
            breakpoint: {}
        }
    }

    handleTabChange = (resource) => {
        if (resource === this.state.selectedTab) {
            return false
        }

        this.setState({
            tabs: this.state.tabs.map((it) => {
                it.current = it.resource === resource
                return it
            }),
            selectedTab: resource
        })
    }

    handleBreakpointChange = (breakpoint) => {
        this.setState({
            breakpoint
        })
    }

    render() {
        const {translate, resource} = this.props

        return (
            <Layout
                onBreakpointChange={this.handleBreakpointChange}
                isAccessible={!(resource.errorStatus === 2)}
                {...this.props}
            >
                <Page>
                    <PageHeader
                        title={translate('title.Maintenance')}
                        afterTitle={(
                            <PageHeaderInfo
                                dispatch={this.props.dispatch}
                            />
                        )}
                    />

                    <div className="hidden sm:block">
                        <NavResponsive
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    <div className="sm:hidden">
                        <MobileTabs
                            tabs={this.state.tabs}
                            onTabChange={this.handleTabChange}
                            translate={translate}
                        />
                    </div>

                    {this.state.selectedTab === Resources.WorkOrderScheduledMaintenance && (
                        <ScheduledMaintenanceTab
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}

                    {this.state.selectedTab === Resources.WorkOrderUpcomingMaintenance && (
                        <UpcomingMaintenanceTab
                            breakpoint={this.state.breakpoint}
                            {...this.props}/>
                    )}
                </Page>
            </Layout>
        )
    }
}

export default connect(state => state)(ScheduledMaintenancePageView)
